const generatorTokens = {
  generatorTokens: {
    generator_tokens: 'Generator Token',
    purchase_dt: 'Purchase Date',
    purchased_from: 'Purchased From',
    status: 'Status',
    site_id: 'Site ID',
    manufacturer_name: 'Manufacturer Name',
    model_info: 'Model Information',
    activation_dt: 'Activation Date',
    footer: 'Generator Tokens',
    total: 'Total',
    records: 'records',
    token: 'Token',
    tokens: 'Tokens',
    show: 'Show',
    to: 'to',
    of: 'of',
    noTokens: '** No Generator Tokens Available **',
    heading: 'Generator Tokens',
    assignToSubContractor: 'Assign to Subcontractor',
    cancel: 'Cancel',
    next: 'Next',
    back: 'Back',
    assign: 'Assign',
    distributorConfirmation: 'I confirm, that this Installer Company has been conveyed the following information:',
    masterDistributorConfirmation: 'I confirm, that this Distributor Company has been conveyed the following information:',
    distributorGeneratorTokens: 'The Generator Tokens can only be used for installing Generators present in the',
    enphaseSupportedGenerator: ' Enphase supported Generator List',
    assignToSubcontractorButton: 'Assign to Authorized Subcontractor',
    noSiteIdTooltip: 'Please complete the Assignment from the Installer Toolkit Application.',
    purchaseDateTooltip: 'Indicates the date and time when this token was purchased from the Enphase Store.',
    unassignmentMsg: 'Please get in touch with ',
    newTokenMessage: 'Newly purchased tokens may take upto 60 minutes to reflect in this table. If it does not reflect after 60 minutes, please get in touch with ',
    tokenReassignMessage: 'Tokens assigned to you by another installer company cannot be reassigned again',
    unassignmentOfTokensMsg: 'if you wish to unassign a token that has already been assigned',
    selectCompany: 'Select Company',
    subcontractor_company: 'Subcontractor Company',
    purchaseNewToken: 'Purchase new Token',
    unassigOfInstallerTokensMsg: 'if you wish to unassign a token that has already been assigned to a Subcontractor',
    redirectToStoreText: 'Redirecting to Enphase Store! Please Wait...!',
    /*distributor*/
    assigned_to: 'Assigned To',
    action: 'Action',
    bulkAssign: 'Bulk Assign',
    addEmailId: 'Add Email ID',
    addEmailIdMessage: 'Provide another company access to this token by entering the email address of an Enphase user from that company.',
    search: 'Search',
    assignToInstaller: 'Assign to Installer',
    assignToDistributor: 'Assign to Distributor',
    enphaseEnergy: 'Enphase Energy',
    ok: 'Ok',
    okay: 'Okay',
    modalTextLarge: 'Your order has been placed successfully!!!',
    modalTextSmall: 'Payment is processing and may take some time to get updated with the latest status.',
    paymentStatus: 'Payment Status',
    noSubcontractorMessage: 'There are no Authorized Subcontractors added for your Company. Please get in touch with your company Admin to add an Authorized Subcontractor.'
  }
};

export default generatorTokens;
